/**
 * API Configuration
 */

// Get port from environment variable or use default
const PORT = import.meta.env.VITE_PORT || 3001

// Use relative path for API calls
export const API_BASE_URL = '/api';

// Enable local fallback for development
export const ENABLE_LOCAL_FALLBACK = false;

// Timeout for API requests in milliseconds
export const API_TIMEOUT = 5000; 